export default __webpack_public_path__ + "static/media/GM_Blue_Horizontal_RGB.d68018bb.svg";